import React, { FC, useState } from 'react';
import { Button, Table } from 'modules';
import { structure } from './configs';
import _ from 'lodash';

const TableElectricBillList: FC = () => {
  const [valueCheckbox, setValueCheckbox] = useState<any>([]);
  return (
    <div className='electric-bill-list'>
      <Table
        structure={structure()}
        hasCheckbox={true}
        onChangeCheckbox={(data) =>
          setValueCheckbox((preState: any) => {
            if (data.value === -1) {
              //data.value === -1 => check all or uncheck all
              if (data?.checked === true) return [data];
              if (data?.checked === false) return [];
            }
            const temp = preState?.filter(
              (item: any) => _.isEqual(item?.value, data?.value) === false,
            );
            if (data?.checked === true) return [...temp, data];
            if (data?.checked === false) return [...temp];
          })
        }
        data={[
          {
            userId: 1,
            avatar: 'avatar1',
          },
          {
            userId: 2,
            avatar: 'avatar2',
          },
        ]}
        addMoreTRTop={true}
        valueCheckbox={valueCheckbox}
        fetchData={async (params) => {
          return {
            count: 1,
            data: [
              {
                userId: 1,
                avatar: 'avatar1',
              },
              {
                userId: 2,
                avatar: 'avatar2',
              },
            ],
          };
        }}
      />

      <div className='electric-bill-list__action'>
        <Button
          label={'Xác nhận'}
          type='submit'
          buttonType='success'
          // isLoading={isSubmitting}
          // onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default TableElectricBillList;
